import { render, staticRenderFns } from "./ShowAnnouncement.vue?vue&type=template&id=554d4b6a&scoped=true"
import script from "./ShowAnnouncement.vue?vue&type=script&lang=js"
export * from "./ShowAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./ShowAnnouncement.vue?vue&type=style&index=0&id=554d4b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554d4b6a",
  null
  
)

export default component.exports